import {Tolgee, DevTools, FormatSimple, BackendFetch} from "@tolgee/react";
import {KEY_LANGUAGE_SESSION_STORAGE} from "../constants/storage";
import dataRetentionEn from "../i18n/data-retention.en.json";
import dataRetentionIt from "../i18n/data-retention.it.json";
import gdprEn from "../i18n/gdpr.en.json";
import gdprIt from "../i18n/gdpr.it.json";

/**
 * Namespace for bundled Data Retention copy. Avoids generic names like "dataRetention"
 * so Tolgee CDN files under the same path do not overwrite our static strings with raw keys.
 */
export const DATA_RETENTION_I18N_NS = "ykConsoleDataRetention";
export const GDPR_I18N_NS = "ykConsoleGdpr";

export const tolgee = Tolgee()
    .use(DevTools())
    .use(FormatSimple())
    .use(BackendFetch({
        prefix: "https://cdn.tolg.ee/2fd42a24b086490cb0c700227fcb3d0b",
        fallbackOnFail: true
    }))
    .init({
        language: sessionStorage.getItem(KEY_LANGUAGE_SESSION_STORAGE) || 'it', // Default language
        fallbackLanguage: 'en', // Fallback language
        staticData: {
            [`en:${DATA_RETENTION_I18N_NS}`]: dataRetentionEn,
            [`it:${DATA_RETENTION_I18N_NS}`]: dataRetentionIt,
            [`en:${GDPR_I18N_NS}`]: gdprEn,
            [`it:${GDPR_I18N_NS}`]: gdprIt,
        },
    });

export const changeLanguage = (language) => {
    sessionStorage.setItem(KEY_LANGUAGE_SESSION_STORAGE, language);
    tolgee.changeLanguage(language)
        .then(() => {
            window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language } }));
        })
        .catch((err) => {
            console.error(`Error changing language: ${err}`);
        });
};